// extracted by mini-css-extract-plugin
export default {"card":"Card_card__G-cji","btnn":"Card_btnn__lszyi"};